import Cookies from "js-cookie";

export default {
    name: "single-product",
    container: null,
    retailers: null,
    stickyEl: null,
    initialPos: null,
    maxPos: null,
    products: [],
    currentIndex: [],
    host: "",

    init() {
        this.container = document.querySelector("#js_theProduct");

        if (!this.container) {
            return;
        }

        this.setProductsNavigation();
        this.stickyMobile = document.querySelector(".product-contact-btn");
        this.stickyDesktop = document.querySelector(".product-sticky");
        

        this.setConfig();

        let width = window.innerWidth;

        window.addEventListener("resize", (e) => {

            if (window.innerWidth !== width) {
                width = window.innerWidth;
                this.setConfig();
            }

        });

        document.addEventListener("scroll", this.run.bind(this));

        this.handleDataLayer();
    },

    run() {

        let device = this.getDevice();

        if (device == "mobile") {
            this.handleMobile();
        }
    
        if (device == "desktop") {
            this.handleDesktop();
        }

    
    },

    handleDataLayer() {

        let productData = this.getCurrentProduct();

        if(!productData){
            return;
        }
        const dataLayerParams = {
            produktnavn: productData.t,
            pris: productData.p,
            salgstype: productData.sf,
            kilometeravstand: productData.m,
            girkasse: productData.tr.value,
            hestekrefter: productData.hp,
            antall_seter: productData.s.value,
            årsmodell: productData.y,
            totalvekt: productData.wt,
            egenvekt: productData.w,
        }

        document.addEventListener("DOMContentLoaded", function () {
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'Sendt inn innbytteskjema',
                    ...dataLayerParams,
                });
                window.dataLayer.push({
                    event: 'Sendt inn skjema - Produkt',
                    ...dataLayerParams,
                });
            }
        });
    },

    setConfig() {

        let device = this.getDevice();

        if (device == "mobile") {
            this.initialPos = this.stickyMobile.getBoundingClientRect().top + document.documentElement.scrollTop;
        }

        if (device == "desktop") {
           this.initialPos = 130;
           this.maxPosDesktop = this.container.offsetHeight - this.stickyDesktop.clientHeight;
        }
    },

    getDevice() {
        return window.innerWidth > 1366 ? "desktop" : "mobile";
    },

    handleDesktop() {

        let scrollTop = document.documentElement.scrollTop;

        if (scrollTop >= this.initialPos  && scrollTop <= this.maxPosDesktop) {
            this.stickyDesktop.classList.add("is-fixed");
            this.stickyDesktop.style.top = scrollTop + "px";
        } else {
            if (scrollTop <= this.initialPos) {
                this.stickyDesktop.classList.remove("is-fixed");
                this.stickyDesktop.style.top = "";
            }
        }
    },

    handleMobile() {
        
        let scrollTop = document.documentElement.scrollTop;

        if (scrollTop >= this.initialPos) {
            this.stickyMobile.classList.add("is-fixed");
        } else {
            this.stickyMobile.classList.remove("is-fixed");
        }
    },

    setProductsNavigation() {
        this.getProducts();
        this.host = document.querySelector('[name="site_root"]').content;

        this.nextBtn = document.querySelector("#js_next-product");
        this.prevBtn = document.querySelector("#js_prev-product");
        this.backBtn = document.querySelector("#js_back-to-search");

        if (!this.nextBtn && !this.prev && !this.backBtn) {
            return;
        }

        if (!this.getNextProductUrl()) {
            this.nextBtn.style.display = "none";
        }

        if (!this.getPrevProductUrl()) {
            this.prevBtn.style.display = "none";
        }

        this.nextBtn.addEventListener("click", (e) => {
            window.location.href = this.host + this.getNextProductUrl();
        });

        this.prevBtn.addEventListener("click", (e) => {
            window.location.href = this.host + this.getPrevProductUrl();
        });

        this.backBtn.addEventListener("click", (e) => {
            
            window.location.href = Cookies.get('vue-search-reference') ?? '/'+this.container.getAttribute("data-resource");
        });
    },

    getProducts() {
        let productsData = this.container.getAttribute("data-products");
        let cookie =  Cookies.get("vue-search");
        this.products = cookie ? JSON.parse(cookie) : JSON.parse(productsData);
    },

    getCurrentIndex() {
        let index;
        let currProductId = parseInt(this.getCurrentProductId());

        this.products.forEach((p, i) => {
            if (p.id === currProductId) {
                index = i;
            }
        });

        return index;
    },

    getCurrentProductId() {
        return this.container.getAttribute("data-product-id");
    },

    getProductUrl(index) {
        return this.products[index] ? this.products[index].u : null;
    },

    getNextProductUrl() {
        let index = this.getCurrentIndex() + 1;
        return this.getProductUrl(index);
    },

    getPrevProductUrl() {
        let index = this.getCurrentIndex() - 1;
        return this.getProductUrl(index) ? this.getProductUrl(index) : null;
    },

    getCurrentProduct() {
        let index = this.getCurrentIndex();
        return this.products[index] ? this.products[index] : null;
    },
};
